export function setData(serviceName: any, data: any) {
  window.localStorage.setItem(serviceName, JSON.stringify(data))
}

export function getData(serviceName: any) {
  const retData = window.localStorage.getItem(serviceName)
  if (retData != null) return JSON.parse(retData)
  return null
}

export function removeData(key: any) {
  window.localStorage.removeItem(key)
}

export function clearSessionData() {
  const isRemember = window.localStorage.getItem('isRemember')
  const userCredentials = window.localStorage.getItem('userCredentials')
  localStorage.clear()
  if (isRemember != null) {
    setData('isRemember', true)
    setData('userCredentials', JSON.parse(userCredentials || ''))
  }
}

export function clearSession() {
  window.localStorage.clear()
  clearSessionData()
}

export function isAuthenticated() {
  // return true
  const auth_details = getData('userDetails')
  if (auth_details) {
    return true
  } else {
    return false
  }
}

export function getHeaders() {
  const userDetails = getData('userDetails')
  if (userDetails != null)
    return {
      User: userDetails && userDetails.data ? userDetails.data.id : 1,
      // User: 11,
      Authorization:
        userDetails && userDetails.data ? 'Bearer ' + userDetails.data.token : '',
    }
  else return { User: userDetails.data.id }
}
